import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import V2 from "./pages/V2";
import SmoothScroll from "./components/v2/SmoothScroll";

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A2540",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "2px",
            fontFamily: "Sofia Sans, sans-serif",
          },
        }}
      />
      <V2 />
    </div>
  );
}

export default App;
